import(/* webpackMode: "eager" */ "/vercel/path0/app/[lang]/auth/forgot-password/page.tsx")